import { withProps } from 'recompose'

import { getMessages } from '../app/selectors'
import content from '../content'

// i18n message string
function Msg({ id, messages }) {
  return messages[id] || id
}

export const withMessages = withProps(ownProps => ({
  messages: getMessages(content),
}))

export default withMessages(Msg)



// WEBPACK FOOTER //
// ./src/components/Msg.js